import './FieldValidationPopupWrapper.scss';
import React from 'react';
import classNames from 'classnames';
import { ErrorSettings } from '../../../../types/template-types';
import { useAppSelector } from '../../../../hooks/ReduxHooks';
import FieldValidationPopup from './FieldValidationPopup';

type FieldValidationPopupWrapperProps = {
  className?: string;
  fieldId?: string;
  x: number;
  y: number;
  width: number;
  height: number;
  errorSettings?: ErrorSettings;
  fieldType?: number;
  focused?: boolean;
  highlighted?: boolean;
  isMissingRequired?: boolean;
};

export default function FieldValidationPopupWrapper(props: FieldValidationPopupWrapperProps) {
  const { className, fieldId, x, y, width, height, errorSettings, fieldType, focused, highlighted, isMissingRequired } = props;

  const isCompleted = useAppSelector((state) => state?.formeditor?.form?.completedDate);
  const containsErrors = !!(errorSettings || isMissingRequired);

  // Don't render if it shouldn't be shown or form is completed
  if (!containsErrors || isCompleted) {
    return null;
  }

  return (
    <div
      className={classNames('error-popup-container', className || '')}
      style={{
        top: `${y}px`,
        left: `${x}px`
      }}
    >
      <svg width={width} height={height}>
        <FieldValidationPopup
          className={className}
          fieldId={fieldId}
          x={x}
          y={y}
          width={width}
          height={height}
          errorSettings={errorSettings}
          fieldType={fieldType}
          focused={focused}
          highlighted={highlighted}
          isMissingRequired={isMissingRequired}
          isCompleted={!!isCompleted}
          containsErrors={containsErrors}
        />
      </svg>
    </div>
  );
}
